import React from "react";
import {EditMembership} from "../../../../UI/Membership/Edit/EditMembership";

const EditMemberShipPage = () => {
  return (
    <div>
      <EditMembership />
    </div>
  );
};

export default React.memo(EditMemberShipPage);
